import dayjs from "dayjs";
import ImageWithBasePath from "../../../../../../core/common/imageWithBasePath";
import { useEffect } from "react";

const MultiplePagePdfSettingClient = ({ printRef, printOutPdfDetails, onRenderReady }: any) => {


    const formatDate = (date: Date | string) => {
        return dayjs(date).format("MMM-D-YYYY").toUpperCase();
    };
    const formattedDate = formatDate(new Date());
    useEffect(() => {
        if (printOutPdfDetails) {
            onRenderReady?.();
        }
    }, [printOutPdfDetails]);
    return (
        <div className="">
            <div ref={printRef} className="d-flex flex-column gap-4" id="22">
                {/* Page 1 */}
                <div className="position-relative" style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden", pageBreakAfter: "always" }}>
                    <header className="w-100 f-f text-center">
                        <div className="row mb-6 justify-content-between align-items-center">
                            <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }} >
                                <div className='d-flex align-items-center justify-content-center text-center'>
                                    <ImageWithBasePath
                                        src={'assets/img/logo.svg'}
                                        className=""
                                        alt="Logo"
                                        width={300}
                                        height={68}
                                    />
                                </div>
                            </div>
                            <div className='col-md-6 d-flex flex-column justify-content-center align-items-center' style={{ flex: '0 0 50%', maxWidth: '50%' }} >
                                <div className="" style={{ textAlign: 'justify' }}>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0 ">Buyer's Name:</p>
                                        <p className="text-sm mb-0">{printOutPdfDetails?.result?.primaryContactFirstName + " " + printOutPdfDetails?.result?.primaryContactLastName}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Address:</p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.propertyAddressLine1}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">City, State, ZIP:</p>
                                        <p className="text-sm  mb-0">{
                                            `${printOutPdfDetails?.result?.propertyCity || ''}${printOutPdfDetails?.result?.propertyCity ? ', ' : ''}${printOutPdfDetails?.result?.propertyState || ''}${printOutPdfDetails?.result?.propertyState ? ', ' : ''}${printOutPdfDetails?.result?.propertyZipCode || ''}`
                                        }</p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Project#: </p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.projectNumber}</p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Date: </p>
                                        <p className="text-sm  mb-0">{formattedDate}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </header>
                    <main className="mt-2 mb-1 py-2 text-center f-f">
                        <h4 className="text-center font-bold  mb-4 mt-3 fs-19 f-f">Setting Client Expectations</h4>
                        <div style={{ textAlign: 'justify' }}>
                            <div className="">
                                The following items should be checked off for each PCC closing and a copy of the document scanned
                                with PCC documents in AFD. Checking off the item confirms that it was discussed with the client and
                                that their expectations are set appropriately. Include notes for any specific issues the client may not be
                                in agreement with or that may be more specific to the project.
                                <div className="mb-5 mt-3">
                                    • Scope defined per plans. All required work included in contract has been reviewed with the client
                                    via the plans where it is clearly defined.
                                </div>
                                <div className="mb-5">
                                    • All scope required for the project but is N.I.C. has been reviewed with the client and clearly
                                    identified on the signed set of plans.
                                </div>
                                <div>
                                    • Construction logistics have been reviewed with the client and they are well aware of all required
                                    inconveniences to their daily lifestyle and understand what parts of the house will be out of
                                    commission and for how long. If necessary to move out of the house the client has been informed
                                    and is in agreement.
                                </div>
                            </div>
                        </div>
                    </main>
                    <footer className="position-absolute bottom-0 w-100 py-2 text-center">
                        <hr className="border-gray-300 bottom-0 my-4 mt-5" />
                        <p className='text-center fs-10 f-f fw-600'>DESIGN & BUILD SHOWROOM | 6825 N. LINCOLN AVE., LINCOLNWOOD IL 60712 | 847-485-1763
                            <br />
                            DESIGN STUDIO | 36 S. WASHINGTON ST., HINSDALE IL 60521 | 630-280-3380
                            <a href='https://Airoom.com'> Airoom.com</a>
                        </p>
                    </footer>
                </div>

                {/* Page 2 */}
                <div className="position-relative" style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden", pageBreakAfter: "always" }}>
                    <header className="w-100 py-3 text-center">
                        <div className="row mb-6 justify-content-between align-items-center" >
                            <div className='col-md-12'>
                                <div className='d-flex align-items-center justify-content-center text-center'>
                                    <ImageWithBasePath
                                        src={'assets/img/logo-small.svg'}
                                        className=""
                                        alt="Logo"
                                        width={90}
                                        height={48}
                                    />
                                </div>
                            </div>
                        </div>

                    </header>
                    <main className="mt-2 mb-1 py-2 text-center f-f">
                        <h4 className="text-center font-bold  mb-4 mt-3 fs-19 f-f">Setting Client Expectations</h4></main>
                    <div style={{ textAlign: 'justify' }}>
                        <div className="">
                            • Construction Timeline has been reviewed with the client including Airoom’s timeline guarantee. Any
                            adjustments per the PCC changes to the timeline have been made, discussed and signed for
                            <div className="mb-5 mt-5">
                                • General construction process has been reviewed with the client including examples of scenarios
                                explaining what could go wrong and how Airoom would deal with it as well as how their relationship with
                                the superintendent works moving forward. Start dates have been discussed and agreed upon and the
                                client is prepared to meet their assigned superintendent for the pre-start meeting.
                            </div>
                            <div className="mt-5">
                                •  Specification Guide has been given to the client and it has been discussed and signed by the client and
                                PM
                            </div>
                        </div>
                        <div className='d-flex justify-content-around mt-5'>
                            <p>Airoom Rep __________________________</p>
                            <p>Date: __________________________</p>
                        </div>
                    </div>
                    <footer className="position-absolute bottom-0 w-100 py-2 text-center">
                        <hr className="border-gray-300 bottom-0 my-4 mt-5" />
                        <p className='text-center fs-10 f-f fw-600'>DESIGN & BUILD SHOWROOM | 6825 N. LINCOLN AVE., LINCOLNWOOD IL 60712 | 847-485-1763
                            <br />
                            DESIGN STUDIO | 36 S. WASHINGTON ST., HINSDALE IL 60521 | 630-280-3380
                            <a href='https://Airoom.com' className="fw-600"> Airoom.com</a>
                        </p>
                    </footer>
                </div>
            </div>
        </div>

    );
};

export default MultiplePagePdfSettingClient;
